export default __webpack_public_path__ + "bfx/static/media/search.4421eb6f.svg";